import { render, staticRenderFns } from "./UserJourney.vue?vue&type=template&id=673e044e&"
import script from "./UserJourney.vue?vue&type=script&lang=js&"
export * from "./UserJourney.vue?vue&type=script&lang=js&"
import style0 from "./UserJourney.vue?vue&type=style&index=0&id=673e044e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports